<template>
  <div class="hello">
    <Header></Header>
    <div class="content_s clearfix">

      <div class="article-content ">
        <h1 class="article__title" v-html="artical_info.title"></h1>
        <p class="text-tip">
        <span label="发布时间">{{artical_info.public_time}}</span>
        <span label="备注" v-if="artical_info.original == 0"></span>
        <span label="备注" v-if="artical_info.original == 1">原创</span>
        <span label="备注" v-if="artical_info.original == 2">非原创</span>
        <span label="备注" v-if="artical_info.original == 3">转载</span>
        <span label="作者">作者：{{artical_info.author}}</span>
        <span label="来源" v-if="artical_info.source_platform != ''">来源：{{artical_info.source_platform}}</span>
        </p>

        <div v-html="artical_info.content">
        </div>
       
        <div class="related-article clearfix">
          <h2>相关推荐</h2>
          <el-col :span="6" v-for="(o, index) in recommendData" :key="index">
            <el-card :body-style="{ padding: '0px'}" @click.native="artical_rute(o._uniquecode)">
                <div class="img_show_thumb">
                  <img :src="o.thumb_image_url" class="image">
                </div>
                
                <div class="shake">
                  <h3>{{o.title}} </h3>
                </div>
            </el-card>
          </el-col>
        </div>
      </div>
    </div>

    <bbottom></bbottom>
    <el-row>
      <el-col>
        <div class="share-article">
          <div class="up-top" @click="toTop">
            <i class="el-icon-arrow-up"></i>
            <i class="uptop-down">返回顶部</i>
          </div>
          <div class="share-wx">
            <div class="share-button" @mouseenter="showCont" @mouseleave="showCont">
            
              <button class="item-wx" slot="reference" >
                <svg class="hx-icon" t="1654481461449" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2177"><path d="M664.250054 368.541681c10.015098 0 19.892049 0.732687 29.67281 1.795902-26.647917-122.810047-159.358451-214.077703-310.826188-214.077703-169.353083 0-308.085774 114.232694-308.085774 259.274068 0 83.708494 46.165436 152.460344 123.281791 205.78483l-30.80868 91.730191 107.688651-53.455469c38.558178 7.53665 69.459978 15.308661 107.924012 15.308661 9.66308 0 19.230993-0.470721 28.752858-1.225921-6.025227-20.36584-9.521864-41.723264-9.521864-63.862493C402.328693 476.632491 517.908058 368.541681 664.250054 368.541681zM498.62897 285.87389c23.200398 0 38.557154 15.120372 38.557154 38.061874 0 22.846334-15.356756 38.156018-38.557154 38.156018-23.107277 0-46.260603-15.309684-46.260603-38.156018C452.368366 300.994262 475.522716 285.87389 498.62897 285.87389zM283.016307 362.090758c-23.107277 0-46.402843-15.309684-46.402843-38.156018 0-22.941502 23.295566-38.061874 46.402843-38.061874 23.081695 0 38.46301 15.120372 38.46301 38.061874C321.479317 346.782098 306.098002 362.090758 283.016307 362.090758zM945.448458 606.151333c0-121.888048-123.258255-221.236753-261.683954-221.236753-146.57838 0-262.015505 99.348706-262.015505 221.236753 0 122.06508 115.437126 221.200938 262.015505 221.200938 30.66644 0 61.617359-7.609305 92.423993-15.262612l84.513836 45.786813-23.178909-76.17082C899.379213 735.776599 945.448458 674.90216 945.448458 606.151333zM598.803483 567.994292c-15.332197 0-30.807656-15.096836-30.807656-30.501688 0-15.190981 15.47546-30.477129 30.807656-30.477129 23.295566 0 38.558178 15.286148 38.558178 30.477129C637.361661 552.897456 622.099049 567.994292 598.803483 567.994292zM768.25071 567.994292c-15.213493 0-30.594809-15.096836-30.594809-30.501688 0-15.190981 15.381315-30.477129 30.594809-30.477129 23.107277 0 38.558178 15.286148 38.558178 30.477129C806.808888 552.897456 791.357987 567.994292 768.25071 567.994292z" p-id="2178"></path></svg>
              </button>
            </div>

            <div class="tanchu" v-show="show">
              <div class="wx-list">
                <div class="ewm">
                    <canvas ref="canvasQr" style="border:1px solid #f1f1f1;"></canvas>
                </div>
              </div>

            </div>
            <div>


            </div>
          </div>

        </div>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  import QRCode from 'qrcode'
  import Header from "@/components/public/Header.vue"
  import bbottom from "@/components/public/bbottom.vue"
  export default {
    name: 'Show',
    data() {
      return {
        tanchu: false,
        show: false,
        activeName: 'first',
        data: ['1', '2', '3', '4'],
        msg: 'shuiahuiah',
        currentDate: new Date(),
        recommendData:[],
        artical_info:''
      }
    },

    props: {},
    created(){
        this.getArticalData()
        this.getArticalCommend()
        this.updateNumb()
    },

    //页面初始化
    computed: {
      seamlessScrollOption() {
        return {
          step: 0.3, // 数值越大速度滚动越快
          limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        };
      },
    },
    mounted() {
      this.makeQrcode();
    },

    //页面加载后执行方法
    methods: {
      makeQrcode(){
        let opts = {
          errorCorrextionLevel:'H',
          type:'image/png',
          quality:0.3,
          width:165,
          height:165,
          text:'1231212',
          color:{
            dark:'#333333',
            light:'#fff',
          }
        }
        var text = 'http://m.iceo.com.cn/article/'+this.$route.params.id
        QRCode.toCanvas(this.$refs.canvasQr,text,opts)
      },

      updateNumb(){
        //更新页面信息
        var config = {
            method: 'POST',
            url: '/api/v1/artical/upnum',
            headers: { 
                'Content-Type': 'application/json'
            },
            data: {art_unique:this.$route.params.id},
          };
          this.$axios(config).then(res=>{
            console.log('请求成功')
          }).catch(error=>{
            console.log('请求失败')
          })
          
      },

      //热点文章跳转
      artical_rute(unique_id){

        this.$router.push({path:'/article/' + unique_id,params:{id:""}})
        document.documentElement.scrollTop = 0
        this.getArticalData()
      },

      getArticalData(){

        //查找页面信息
        var config = {
            method: 'GET',
            url: '/api/v1/artical/detail/' + this.$route.params.id,
            headers: { 
                'Content-Type': 'application/json'
            },
            params: {art_unique:this.$route.params.id}
          };

          this.$axios(config).then(res=>{
            
           this.$data.artical_info = res.data
    
            console.log('请求成功')
            //更新数据  文章 视频 快讯 杂志 专题
            //title dect time  关键字标红  后台敏感词过滤标志 status_by  sqllite
          }).catch(error=>{
            console.log('请求失败')
          })


        },

        getArticalCommend(){

        //查找页面信息
        var config = {
            method: 'GET',
            url: '/api/v1/artical/commend/' + this.$route.params.id,
            headers: { 
                'Content-Type': 'application/json'
            },
            // params: {art_unique:this.$route.params.id}
          };

          this.$axios(config).then(res=>{
            
           this.$data.recommendData = res.data
    
            // console.log('请求成功')
            //更新数据  文章 视频 快讯 杂志 专题
            //title dect time  关键字标红  后台敏感词过滤标志 status_by  sqllite
          }).catch(error=>{
            console.log('请求失败')
          })


      },

       loadFullScreen() {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 300);
      },

      showCont: function () {
        this.show = !this.show;
      },
     
      toTop() {
        document.documentElement.scrollTop = 0;
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      submit_data() {
        // this.$router.push('/collect')
      },
      handleClick(tab, event) {
        console.log(tab, event);
      }

    },
    //组件引入
    components: {
      Header,
      bbottom
    },
  }

</script>

<style scoped>
  .img_show_thumb{
    height: 120px;
    overflow: hidden;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .content_s {
    width: 1200px;
    margin: 25px auto;
  }

  .img_s {
    width: 100%;
    border-radius: 6px;
  }

  .top {
    width: 1200px;
    margin: 0 auto;
  }

    .top img {
      display: block
    }

  .baomin {
    display: relative;
    width: 60%;
    height: 32px;
    border: white solid 2px;
    border-radius: 6px;
    text-align: center;
    color: white;
    position: absolute;
    top: 60%;
    left: 50%;
    margin-top: -50px;
    margin-left: -100px;
  }

  .fonts_bao {
  }

  .hello {
    color: rgb(0, 0, 0);
  }

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

        
  .button {
    padding: 0;
    float: right;
  }

 .image{
  width: 108%;
  display: block;
  position: relative;
  top: -6px;
  left: -6px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .item h3 {
    color: #e85a50;
  }

  .icon_s {
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #eea01e;
    text-align: center;
    line-height: 30px;
    border-radius: 10px;
    margin-right: 15px;
    /* color:#fa5c00; */
    color: white;
  }

  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-row {
    margin-bottom: 0px;
  }

  .el-col {
    /* margin-right:30px; */
    border-radius: 4px;
  }



  /*文章*/
  .article-content {
    width: 880px;
    padding: 20px 0px;
    margin: 0 auto;
  }

    .article-content >>> img {
      max-width: 100%;
      display: block;
      margin: 0 auto!important;
    }

    .article-content >>> span,.article-content >>> strong {
      font-size: 16px;
      line-height: 24px!important;
    }
 .article-content >>>  p br{
 display:none;
 }

  .article__title {
    font-family: Helvetica,Arial,'Microsoft YaHei','微软雅黑',STHeitiSC-Light,simsun,'宋体','WenQuanYi Zen Hei','WenQuanYi Micro Hei',sans-serif;
    font-size: 32px;
    line-height: 46px;
    color: #4b4b4b;
    font-weight: normal;
    margin: 0px;
    text-align: center;
  }

  .text-tip {
    font-size: 16px;
    color: #999 !important;
    margin: 10px 15px 25px 0px;
    
    text-align: center;
  }

    .text-tip span {
      display: inline-block;
      margin: 0px 10px;
    }

  .text-big-font， .text-big-font strong {
    font-size: 24px !important;
  }

  .related-article {
    width: 100%;
    margin: 50px auto;
  }

    .related-article h2 {
      margin-bottom: 14px;
      color: #4b4b4b;
      font-size: 18px;
      line-height: 28px;
      font-weight: 500;
    }

  .el-card {
    margin: 16px 8px;
    cursor: pointer;
  }

    .el-card:hover .shake {
      cursor: pointer;
      transform: translateY(6px);
      transition: all .3s ease-in;
    }

    .el-card h3 {
      margin: 0px;
      padding: 0px 10px;
      font-size: 14px;
       line-height: 22px;
      height: 44px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      margin: 10px 0px;
      overflow: hidden;
    }
  /*悬浮图标*/
  .share-article {
    position: fixed;
    bottom: 150px;
    left: 50%;
    margin-left: 600px;
    z-index: 1000;
  }

  .up-top, .share-wx {
    width: 40px;
    height: 40px;
    position: relative;
    margin: 10px auto;
  }

  .uptop-down, .sharewx-down {
    position: absolute;
    left: 0px;
    top: 0px;
    opacity: 0;
    line-height: 20px;
    font-size: 12px;
    font-style: normal;
    background-color: #fff;
  }

  .el-icon-arrow-up {
    line-height: 38px;
  }

  .share-article .el-icon-share, .up-top, .sharewx-down {
    color: #ccc;
    font-size: 24px;
    vertical-align: middle;
    border: 1px solid #ccc;
    border-radius: 30px;
    cursor: pointer;
    display: block;
    text-align: center;
    width: 38px;
    height: 38px;
    background: none;
    overflow: hidden;
  }

    .share-article .el-icon-share:hover, .up-top:hover .uptop-down {
      color: #4b4b4b;
    }

    .up-top:hover .uptop-down, .share-button:hover .sharewx-down {
      border-radius: 30px;
      width: 30px;
      height: 30px;
      line-height: 16px;
      padding: 4px;
      font-size: 12px;
      transition: all .2s ease-in;
      color: #4b4b4b;
      display: block;
      background-color: #fff;
    }

  .share-button:hover .sharewx-down {
    line-height: 30px;
    transition: all .2s ease-in;
    width: 38px;
    height: 38px;
  }

  .up-top:hover .uptop-down, .share-button:hover .sharewx-down {
    opacity: 1
  }

  .item-wx, .item-wb {
    width: 38px;
    height: 38px;
    background-color: transparent;
    border: 1px solid #ccc;
    font-size: 16px;
    -webkit-transition: .3s;
    -o-transition: .3s;
    transition: .3s;
    color: #999;
    border-radius: 30px;
    margin: 5px auto;
    cursor: pointer;
  }

  .hx-icon, .wb-icon {
    vertical-align: middle;
    fill: currentColor;
    overflow: hidden;
  }

  .tanchu {
    position: absolute;
    left: -50px;
    top: -30px;
    width: 40px;
    display: block;
    transition: all 1s ease-in;
    cursor: pointer;
  }

  .ewm {
    position: absolute;
    left: -130px;
    top: -20px;
    display: block;
  }
  .wx-list{
    position:relative;

  }
   
</style>



// WEBPACK FOOTER //
// src/components/Article.vue